import axios from "axios";
import { axiosInstance } from "../authService";
import ApiUrlConstant from "../Constants";
const headers = { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY }
const headersFormData = { "Ocp-Apim-Subscription-Key": process.env.REACT_APP_API_KEY, "Content-Type": "multipart/form-data" }

const inspectionService = {
    getInspections: (params = {}, token) => {
        return axiosInstance.get(ApiUrlConstant.inspectionListing(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    getInspection: (id, token) => {
        return axiosInstance.get(ApiUrlConstant.getInspection(id), {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    addInspection: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.addInspection(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    updateInspection: (id, data, token) => {
        return axiosInstance.put(ApiUrlConstant.updateInspection(id), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    deleteInspection: (params = {}, token) => {
        return axios.delete(ApiUrlConstant.deleteInspection(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    getInspectionforProject: (params = {}, token) => {
        return axios.get(ApiUrlConstant.getInspectionforProject(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    archiveInspection: (params = {}, token) => {
        return axiosInstance.delete(ApiUrlConstant.archiveInspection(), {
            params, headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        });
    },
    cloneInspection: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.cloneInspection(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },
    inspectionStarted: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.inspectionStarted(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`,
            },
        })
    },

    // report generation 
    reportGenerated: (data, token) => {
        return axiosInstance.post(ApiUrlConstant.reportGenerate(), data, {
            headers: {
                ...headers,
                Authorization: `Bearer ${token}`
            },
        })
    }
}

export default inspectionService